import { useRouter } from 'next/router';

// Routes
import {
    ACCOUNT,
    DATA_ACCESS,
    PLATFORM_OPTIONS,
    SECURITY,
    SOCIAL_PROFILES,
    SUBSCRIPTION,
    THEMES,
    USERS_ROLES,
    SUBSCRIPTION_INVOICES,
    REFERRAL_PROGRAM,
    NOTIFICATIONS,
    INTEGRATIONS,
    GROUPS,
    REPORTS,
    REPORTS_ACCOUNTS,
    REPORTS_DASHBOARDS,
    REPORTS_COMPETITORS,
    REPORTS_HASHTAGS,
    INSPIRATION,
    SCHEDULER
} from '@/lib/routes/privateRoutes';

// Hooks
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

const URLS_WITHOUT_FIRST_STATS = [
    ACCOUNT,
    DATA_ACCESS,
    USERS_ROLES,
    SOCIAL_PROFILES,
    PLATFORM_OPTIONS,
    SECURITY,
    THEMES,
    SUBSCRIPTION,
    SUBSCRIPTION_INVOICES,
    REFERRAL_PROGRAM,
    NOTIFICATIONS,
    INTEGRATIONS,
    GROUPS,
    REPORTS,
    REPORTS_ACCOUNTS,
    REPORTS_DASHBOARDS,
    REPORTS_COMPETITORS,
    REPORTS_HASHTAGS,
    INSPIRATION,
    SCHEDULER
];

const useDisplayFirstStatsPanel = () => {
    const { activeSocialProfile } = useActiveSocialProfile();

    const { pathname } = useRouter();
    const urlWithoutParams = pathname.split('?')[0];

    return {
        hidePanel:
            activeSocialProfile?.first_stats ||
            activeSocialProfile?.full_stats ||
            URLS_WITHOUT_FIRST_STATS.includes(urlWithoutParams) ||
            !activeSocialProfile
    };
};

export default useDisplayFirstStatsPanel;
